var path = '/templates/zenclerk_s/sites/activity/realtime/realtime.html';
var html = "<div class=activity><zc-realtime-visitor-visualizer project=project></zc-realtime-visitor-visualizer></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_s_modules/zenclerk_s/sites/activity/realtime/realtime.html
// module id = 1375
// module chunks = 0